import { getStorageElement, setStorageElement } from 'services/storage.service';
import * as actions from './actionsTypes';

export const STORAGE_KEY = 'hybridSimState';

const loadInitialState = () => {
    try {
        const raw = getStorageElement(STORAGE_KEY);
        return raw ? JSON.parse(raw) : {};
    } catch (e) {
        return {};
    }
};

const saveState = (state) => {
    try {
        setStorageElement(STORAGE_KEY, state);
    } catch (e) {
        // localStorage full or unavailable — fail silently, Redux state still works in-memory
    }
};

const initialState = loadInitialState();

const hybridReducer = (state = initialState, action) => {
    let newState;

    switch (action.type) {
        case actions.SET_HYBRID_PENDING:
            newState = {
                ...state,
                [action.orderId]: {
                    ...state[action.orderId],
                    pending: true,
                    packageData: action.packageData,
                    error: false,
                },
            };
            break;

        case actions.CLEAR_HYBRID_PENDING: {
            const { [action.orderId]: _removed, ...rest } = state;
            newState = rest;
            break;
        }

        case actions.SET_HYBRID_ERROR:
            newState = {
                ...state,
                [action.orderId]: {
                    ...state[action.orderId],
                    pending: false,
                    error: true,
                },
            };
            break;

        case actions.CLEAR_HYBRID_ERROR:
            newState = {
                ...state,
                [action.orderId]: {
                    ...state[action.orderId],
                    error: false,
                },
            };
            break;

        case actions.RESET_HYBRID:
            newState = {};
            break;

        default:
            return state;
    }

    saveState(newState);
    return newState;
};

export default hybridReducer;